<div style="width: auto; overflow: auto">
  <app-common-list-table
    [request]="getRequest"
    [cols]="cols"
    [filtering]="filter"
    [actionButtonText]="env.canAddFincas ? 'Añadir ' + env.fincaName : ''"
    (actionButtonClick)="add()"
    [globalConditionalStyle]="globalConditionalStyle"
    [globalVisualTransform]="globalVisualTransform"
    [customExportCsv]="env.showFincasCsv"
    (visualize)="show('info', $event)"
    (edit)="edit($event)"
    (remove)="show('delete', $event)">

    <!-- Header slot -->
    <ng-template #header>
      <div class="ms-3">
        <button class="mx-2 btn"
                (click)="downloadCsv()"
                style="padding: 5px; font-size: .8rem; background-color: #16A2B7; color: white">
          <i class="fa fa-download"></i>
          Exportar listado
        </button>
      </div>
    </ng-template>

    <!-- Extra table headers -->
    <ng-template #thEnd>
      @if (env.showCuadernoDeCampo) {
        <th><p class="d-flex justify-content-center mb-0">
          {{ env.appName === 'donjardin' ? 'Registro Transacciones' : 'Cuaderno' }}
        </p></th>
      }
      <th><p class="d-flex justify-content-center mb-0">Acciones</p></th>
      @if (env.showCargaPAC) {
        <th><p class="d-flex justify-content-center mb-0">PAC</p></th>
      }
      @if (env.showFincasGenGml) {
        <th><p class="d-flex justify-content-center mb-0">GML</p></th>
      }
      @if (env.activateREA) {
        <th><p class="d-flex justify-content-center mb-0">REA</p></th>
        <th><p class="d-flex justify-content-center mb-0">CUE</p></th>
      }
    </ng-template>

    <!-- Extra table cells -->
    <ng-template #tdEnd let-data>
      @if (env.showCuadernoDeCampo) {
        <td>
          <div class="d-flex justify-content-center">
            <button (click)="show('generate', data); filterSectores()"
                    class="d-flex justify-content-center align-items-center"
                    style="height: 20px; width: 85px; border: none; border-radius: 3px; background-color: #345fdc; color: white; cursor: pointer;">
              <i class="fa fa-book"></i>
              <span>&nbsp;Generar</span>
            </button>
          </div>
        </td>
      }

      <td>
        <app-action-buttons
          [hideEdit]="!env.canEditFincas"
          [hideDelete]="!env.canDeleteFincas"
          [showDuplicate]="env.canDuplicateFinca"
          (duplicateRowButtonEvent)="duplicate(data.data)"
          (editRowButtonEvent)="edit(data.data)"
          (deleteRowButtonEvent)="show('delete', data.data)"
          (showRowButtonEvent)="show('info', data.data)">
        </app-action-buttons>
      </td>

      @if (env.showCargaPAC) {
        <td>
          <div class="d-flex justify-content-center">
            <button class="d-flex justify-content-center align-items-center"
                    (click)="uploadDialog(data.data)"
                    style="height: 20px; width: 45px; border-radius: 3px; border: none; background-color: #28a645; color: white">
              <i class="fa fa-upload"></i>
            </button>
          </div>
        </td>
      }

      @if (env.showFincasGenGml) {
        <td>
          <div class="d-flex justify-content-center">
            <button class="d-flex justify-content-center align-items-center"
                    (click)="generaGML(data.data)"
                    style="height: 20px; width: 45px; border-radius: 3px; border: none; background-color: #2863a6; color: white">
              <i class="fa fa-download"></i>
            </button>
          </div>
        </td>
      }

      @if (env.activateREA) {
        <td>
          <div class="d-flex justify-content-center">
            <button class="d-flex justify-content-center align-items-center"
                    (click)="show('importREA', data.data)"
                    style="height: 20px; width: 45px; border-radius: 3px; border: none; background-color: #a67e28; color: white">
              <i class="fa fa-download"></i>
            </button>
          </div>
        </td>

        <td>
          <div class="d-flex justify-content-center">
            <button [pTooltip]="tooltipContent"
                    class="d-flex justify-content-center align-items-center"
                    (click)="show('sendCUE', data.data)"
                    style="height: 20px; width: 45px; border-radius: 3px; border: none; background-color: #a23001; color: white">
              @if (data.data.estado_cue === 'completo') {
                <i class="fa fa-upload"></i>
              } @else if (data.data.estado_cue === 'en_proceso') {
                <i class="fa fa-spinner fa-spin"></i>
              } @else if (data.data.estado_cue === 'no_proceso') {
                <i class="fa fa-times"></i>
              } @else {
                <i class="fa fa-upload"></i>
              }
            </button>

            <ng-template #tooltipContent>
              <div class="d-flex flex-column">
                <p>Estado del CUE</p>
                @if (data.data.estado_cue === 'completo') {
                  <p><i class="fa fa-check-circle"></i> Completo</p>
                }
                @if (data.data.estado_cue === 'en_proceso') {
                  <p><i class="fa fa-spinner fa-spin"></i> En proceso</p>
                }
                @if (data.data.estado_cue === 'no_proceso') {
                  <p><i class="fa fa-times"></i> No proceso</p>
                }
              </div>
            </ng-template>
          </div>
        </td>
      }
    </ng-template>
  </app-common-list-table>
</div>

<!-- Shared modals host -->
<app-modals
  [view]="this"
  [form]="form?.formFields"
  [serverUrl]="env.serverUrl"
  [previousData]="model"
  [recordHasAssociatedData]="true"
  [getRequest]="getRequest"
  [deleteRequest]="deleteRequest">
</app-modals>

<p-dialog width="600"
          header="Importar datos PAC"
          [closeOnEscape]="false"
          [closable]="false"
          [(visible)]="showModalPAC"
          (onShow)="scrollToTop()">
  @if (showModalPAC) {
    <div style="width: 36vw !important">
      <p-fileUpload
        name="myfile[]"
        [disabled]="!enableUpload"
        [multiple]="false"
        [showCancelButton]="false"
        chooseLabel="Seleccionar archivo"
        uploadLabel="Enviar"
        [url]="urlUpload"
        (onSelect)="checkFile($event)"
        (onUpload)="uploaded($event)">
      </p-fileUpload>

      @if (showPACError) {
        <br />
        <p style="max-width: 400px; text-align: center; color: red" [innerHTML]="txtPACError"></p>
        <p style="max-width: 400px; text-align: center; color: green" [innerHTML]="txtPACInfo"></p>
      }

      <br />
      <div class="d-flex justify-content-center">
        <button class="btn btn-dark mx-2" (click)="closeFUDialog()">Cerrar</button>
      </div>
      <br />
    </div>
  }
</p-dialog>

  <p-dialog [visible]="canShow['importREA'] ?? false"
            header="Importar REA"
            [style]="{ width: '50dvw' }"
            [modal]="true"
            [closable]="false"
            id="export-rea-dialog">
    <ng-template pTemplate="body">
      <div class="p-fluid">
        <div class="p-field p-col-12 p-md-6">
          <label>Codigo REA</label> : {{ model.codigo_REA }}
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label>NIF</label>: {{ model.nif }}
        </div>
      </div>

      <div class="d-flex flex-column justify-content-center align-content-center mx-5">
        <div>
          @if (historicoREA?.statusCode === 201) {
            <p-message class="mx-5" severity="info">Nueva importacion</p-message>
          }
          @if (historicoREA?.statusCode === 200) {
            <p-message class="mx-5" severity="info">
              Última importación: {{ historicoREA?.data.fecha }}
            </p-message>
          }
        </div>

        @if (showSpinner) {
          <p-progress-spinner styleClass="p-component-overlay m-auto" strokeWidth="6" animationDuration="1.5s" />
        }

        @if (importResult?.statusCode === 202) {
          <div class="w-100">
            <p-card>
              <h4>Detalle de importación</h4>
              <hr />
              <p>Parcelas no insertadas: <b>{{ importResult?.data.parcelasNoInsertadas }}</b></p>
              <p>Parcelas insertadas: <b>{{ importResult?.data.parcelasInsertadas }}</b></p>
              <p>Parcelas no actualizadas: <b>{{ importResult?.data.parcelasNoActualizadas }}</b></p>
              <p>Parcelas actualizadas: <b>{{ importResult?.data.parcelasActualizadas }}</b></p>
            </p-card>
          </div>
        }

        @if (messageState === 'warning') {
          <p-message class="mx-5" severity="warn">Falta datos para exportar REA</p-message>
        }
        @if (messageState === 'error') {
          <p-message class="mx-5" severity="error">{{ importResult?.statusMessage }}</p-message>
        }
        @if (messageState === 'success') {
          <p-message class="mx-5" severity="success">{{ importResult?.statusMessage }}</p-message>
        }
      </div>
    </ng-template>

    <ng-template #footer>
      <div class="d-flex justify-content-center align-content-center gap-5 w-100">
        @if (importResult?.statusCode) {
          <button class="btn btn-dark mx-2"
                  (click)="hide('importREA'); showSpinner = false; messageState = ''">
            Volver
          </button>
        } @else {
          <button class="btn btn-dark bg-gradient"
                  (click)="hide('importREA'); showSpinner = false; messageState = ''">
            Cancelar
          </button>
        }
        <button class="btn btn-success bg-gradient"
                (click)="showSpinner = true; exportREA(model)">
          Continuar
        </button>
      </div>
    </ng-template>
  </p-dialog>


  <p-dialog [visible]="canShow['sendCUE'] ?? false"
            header="Exportar CUE"
            [style]="{ width: '45vw', height: '60vh' }"
            [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
            [modal]="true"
            [closable]="true"
            id="export-cue-dialog">
    <div>
      <p-card>
        <div class="d-flex flex-row justify-content-between align-items-center">
          <div class="d-flex flex-column">
            <h4>Detalles de la finca</h4>
            <p class="text-muted">
              <small>Utlima fecha de generación: </small><br />
              <span>{{ statusCue?.fecha | date: 'dd/MM/yyyy' }}</span>
            </p>
          </div>

          @switch (statusCue?.estado) {
            @case ('0')   { <span class="text-warning border border-1 border-warning p-2 rounded-4"> Generando CUE </span> }
            @case ('1')   { <span class="text-success border border-1 border-success p-2 rounded-4"> Disponible </span> }
            @case ('2')   { <span class="text-danger  border border-1 border-danger  p-2 rounded-4"> No se pudo generar el CUE </span> }
            @default      { <span class="text-success border border-1 border-success p-2 rounded-4"> Disponible </span> }
          }
        </div>

        <div class="d-flex flex-column justify-between">

          @if(cueHistory.length > 0) {
            <label>Historial CUE</label>
            <select>
              <option value="" selected>Seleccione una opción</option>
              @for (item of cueHistory; track $index) {
                <option [value]="item?.fecha" >{{ item?.fecha }}</option>
              }
            </select>
          }
        </div>

        <hr />

        <div class="d-flex flex-row justify-content-between g-5 gap-5">
          <div class="w-50">
            <h4>General</h4>
            <p class="d-flex gap-2"><b>Finca:</b> {{ model.nombre }}</p>
            <p class="d-flex gap-2"><b>Tipo de explotación:</b> {{ model.tipo_explotacion }}</p>
            <p class="d-flex gap-2"><b>Codigo REA:</b> {{ model.codigo_REA }}</p>
            <p class="d-flex gap-2"><b>Comunidad autónoma:</b> {{ model.comunidad_autonoma_INE }}</p>
            <p class="d-flex gap-2"><b>NIF:</b> {{ model.nif }}</p>
          </div>
          <div class="w-50">
            <h4>Titular</h4>
            <p class="d-flex gap-2"><b>Nombre:</b> {{ model.titular_nombre }}</p>
            <p class="d-flex gap-2"><b>Localidad:</b> {{ model.titular_localidad }}</p>
            <p class="d-flex gap-2"><b>Provincia:</b> {{ model.titular_provincia }}</p>
            <p class="d-flex gap-2"><b>Teléfono:</b> {{ model.titular_telefono }}</p>
            <p class="d-flex gap-2"><b>Email:</b> {{ model.titular_email }}</p>
          </div>
        </div>

        @if (showSpinner) {
          <p-progress-spinner styleClass="p-component-overlay m-auto" strokeWidth="6" animationDuration="1.5s" />
        }

        @if (messageState) {
          <p-panel [toggleable]="true">
            <ng-template #header>
              @if (messageState === 'warning') {
                <p [ngStyle]="{ color: 'yellow' }">{{ importResult?.statusMessage }}</p>
              }
              @if (messageState === 'error') {
                <p [ngStyle]="{ color: 'red' }">{{ importResult?.statusMessage }}</p>
              }
              @if (messageState === 'success') {
                <p [ngStyle]="{ color: 'green' }">{{ importResult?.statusMessage }}</p>
              }
            </ng-template>
            <p>{{ importResult?.data[0]?.body }}</p>
          </p-panel>
        }
      </p-card>
    </div>

    <ng-template pTemplate="footer">
      <div class="d-flex justify-content-center align-content-center gap-5 w-100">
        @if (importResult?.statusCode) {
          <button class="btn btn-dark mx-2"
                  (click)="hide('sendCUE'); showSpinner = false; messageState = ''">
            Volver
          </button>
        } @else {
          <button class="btn btn-dark bg-gradient"
                  (click)="hide('sendCUE'); showSpinner = false; messageState = ''">
            Cancelar
          </button>
        }
        <button class="btn btn-success bg-gradient" (click)="showSpinner = true; exportCUE(model)">
          Continuar
        </button>
      </div>
    </ng-template>
  </p-dialog>
